import { graphql } from "@cappelendamm/crystallize-types/pim/gql";
import Logger from "@cappelendamm/logger";
export const updateOrder = async ({ id, ...input }, { client }) => {
    Logger.log("Updating order in Crystallize: ", JSON.stringify({ id, input }));
    const response = await client.pim.request(graphql(`
      mutation UpdateOrder($id: ID!, $input: UpdateOrderInput!) {
        order {
          update(id: $id, input: $input) {
            id
          }
        }
      }
    `), { id, input });
    return response.order?.update.id;
};
